import { APP_BUILD_VERSION } from '@/core/buildVersion';

export const CLIENT_VERSION_HEADER = 'X-Client-Version';
export const SERVER_VERSION_HEADER = 'x-app-version';
export const CLIENT_VERSION_STORAGE_KEY = 'clientAppVersion';
export const VERSION_MISMATCH_CODE = 'CLIENT_VERSION_MISMATCH';

export function getClientBuildVersion() {
    return APP_BUILD_VERSION || 'dev';
}

export function persistClientBuildVersion(version = getClientBuildVersion()) {
    if (typeof window === 'undefined') {
        return;
    }

    localStorage.setItem(CLIENT_VERSION_STORAGE_KEY, version);
}

export function getStoredClientBuildVersion() {
    if (typeof window === 'undefined') {
        return getClientBuildVersion();
    }

    return localStorage.getItem(CLIENT_VERSION_STORAGE_KEY) || getClientBuildVersion();
}

export function extractServerVersion(headers = {}) {
    if (!headers) {
        return null;
    }

    return headers[SERVER_VERSION_HEADER] || headers[SERVER_VERSION_HEADER.toUpperCase()] || null;
}

export function isVersionMismatch(serverVersion, clientVersion = getClientBuildVersion()) {
    return Boolean(serverVersion) && Boolean(clientVersion) && serverVersion !== clientVersion;
}

export function isClientVersionMismatchError(error) {
    return error?.response?.status === 409 && error?.response?.data?.code === VERSION_MISMATCH_CODE;
}

export function isAppUpdateError(error) {
    return isClientVersionMismatchError(error) || (error?.response?.status === 503 &&
        ['APP_UPDATE_IN_PROGRESS', 'APP_UPDATE_UNAVAILABLE'].includes(error?.response?.data?.code));
}
